module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.81daa868.jpeg";